import React, { useCallback } from 'react';
import PrevIcon from '@moda/icons/prev-16';
import NextIcon from '@moda/icons/next-16';
import { Text, Clickable, LoadingBalls } from '@moda/om';
import classNames from 'classnames';
import { useUrlParams } from '../../../hooks/useUrlParams';
import { useTrackLookEvent } from '../../LookTracking';
import { useLook } from '../useLook';

import './LooksCarouselItemHeaderNavigation.scss';

interface Props {
  className?: string;
}

export const LooksCarouselItemHeaderNavigation: React.FC<Props> = ({ className }) => {
  const {
    params: { look: lookId },
    addParams
  } = useUrlParams();
  const { position, numberOfLooks, nextLookId, prevLookId, loading } = useLook(lookId);

  const trackLookEvent = useTrackLookEvent();

  const goToLook = useCallback(
    (id: number | null | undefined, direction: 'next' | 'previous') => {
      if (!id) return;

      trackLookEvent('Next Look Clicked', {
        look_id: id.toString(),
        from_look_id: typeof lookId === 'string' ? lookId : null,
        direction,
        method: 'arrow'
      });
      addParams({ look: id.toString() });
    },
    [addParams, lookId, trackLookEvent]
  );

  return (
    <nav className={classNames('LooksCarouselItemHeaderNavigation', className)}>
      <Clickable
        disabled={!prevLookId}
        onClick={() => goToLook(prevLookId, 'previous')}
        aria-label="Previous"
      >
        <PrevIcon />
      </Clickable>

      {loading && <LoadingBalls />}

      {!loading && <Text>{`LOOK ${position} / ${numberOfLooks}`}</Text>}

      <Clickable
        disabled={!nextLookId}
        onClick={() => goToLook(nextLookId, 'next')}
        aria-label="Next"
      >
        <NextIcon />
      </Clickable>
    </nav>
  );
};
